import { render, staticRenderFns } from "./business-detail.component.html?vue&type=template&id=77b1a2b2&scoped=true&"
import script from "./business-detail.component.ts?vue&type=script&lang=ts&"
export * from "./business-detail.component.ts?vue&type=script&lang=ts&"
import style0 from "./business-detail.component.scss?vue&type=style&index=0&id=77b1a2b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b1a2b2",
  null
  
)

export default component.exports